import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";

export const MainContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isEditMode",
})<{ isEditMode?: boolean }>(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    flexWrap: "nowrap",
    // backgroundColor : theme.palette.background.paper,
    // gap: "10px"
  }),
  ({ isEditMode, theme }) => ({
    ...(!!isEditMode && {
      height: "65vh",
    }),
  })
);

export const FieldsContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isEditMode",
})<{ isEditMode?: boolean }>(
  ({ theme }) => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    // marginTop: "10px",
    overflow: "auto",
    backgroundColor: theme.palette.background.paper,
    padding: "20px",

    "& .MuiBox-root": {
      // display: "flex",
      gap: "10px",

      "&>div": {
        width: "100%",
      },
    },
  }),
  ({ isEditMode, theme }) => ({
    ...(!!isEditMode && {
      "& .MuiBox-root": {
        display: "flex",
        flexDirection: "column",
        gap: "10px",

        "&>div": {
          width: "100%",
        },
      },
    }),
  })
);
